<script>
export default {
  methods: {
    validateCountry() {
      this.$nextTick(() => {
        if (!this.$refs.country?.validate) {
          if (!this.$refs.country?.id) {
            this.$set(
              this.errors,
              'country_id',
              'Country should not be empty',
            );
          } 
        } else {
          this.$delete(this.errors, 'country_id');
        }
      });
    },
  },
};

</script>
